import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useUpdateEffect } from 'react-use'

import { enablePayment } from '../../../actions/actions'
import { getCompany, getDigiData, getPayment, getSummary, isAgentLogged } from '../../../selectors/selectors'
import Button from '../../common/Button'
import DeliveryDetails from '../DeliveryDetails/DeliveryDetails'
import PaymentTabs from '../Payment/PaymentTabs/PaymentTabs'
import PaymentIcons from './PaymentIcons/PaymentIcons'
import s from './PaymentSection.module.scss'

export default function PaymentSection() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const deliveryDetailsRef = useRef()
  const { loading: summaryLoading } = useSelector(getSummary)
  const { initialized: paymentInitialized, enabled: paymentEnabled } = useSelector(getPayment)
  const { agentRequired } = useSelector(getCompany)
  const agentLogged = useSelector(isAgentLogged)
  const digiData = useSelector(getDigiData)
  const country = digiData?.website?.country || 'fi'

  useUpdateEffect(() => {
    if (paymentEnabled) {
      // eslint-disable-next-line no-unused-expressions
      deliveryDetailsRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
    }
  }, [paymentEnabled])

  return paymentEnabled ? (
    <>
      <DeliveryDetails ref={deliveryDetailsRef} />
      <PaymentTabs />
    </>
  ) : (
    <>
      <div className={s['button-container']}>
        <Button
          className="button-primary-xlg"
          disabled={summaryLoading || !paymentInitialized || (agentRequired && !agentLogged)}
          onClick={() => dispatch(enablePayment())}
        >
          {t('common.buyTickets')}
        </Button>
      </div>
      {country === 'fi' && <PaymentIcons />}
    </>
  )
}
